module.exports = __webpack_public_path__ + "static/media/Buyers Infographic Desktop - GBR network - 30-05-2024 N.19ce566f.gif";